import { ResponseStatus, WidgetStyle } from '@sdbn/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Smartphone } from '../model/smartphone';
import { SmartphoneService } from '../service/smartphone.service';
import { SmartphoneDetails } from '../model/smartphone-details';
import { TranslationService } from '@sdbn/common';
import { MatDialog } from '@angular/material/dialog';
import { ResponseMessage } from '@sdbn/common';
import { NgForm } from '@angular/forms';
import { ContextChange } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { EquipmentIdentifier, EquipmentType } from '@sdbn/tmc-common';
import { ConfirmDialogComponent, ConfirmDialogData } from '@sdbn/tmc-legacy';
@Component({
  selector: 'app-smartphone',
  templateUrl: './smartphone.component.html',
  styleUrls: ['./smartphone.component.scss']
})
export class SmartphoneComponent extends AbstractWidgetComponent implements OnInit {

  smartphones: Smartphone[] = [];

  equipmentIdentifier: EquipmentIdentifier;

  selectedSmartphone: Smartphone;
  selectedDetails: SmartphoneDetails = new SmartphoneDetails();
  workingCopyDetails: SmartphoneDetails = new SmartphoneDetails();

  responseMessages: ResponseMessage[];
  isLoading = false;

  @ViewChild('smartphoneForm') form: NgForm;

  get cancelEnabled() {
    return !this.isLoading && this.form != null && this.form.dirty;
  }

  get saveEnabled() {
    return !this.isLoading && this.form != null && this.form.dirty && this.form.valid;
  }

  constructor(
    public translationService: TranslationService,
    private smartphoneService: SmartphoneService,
    private dialog: MatDialog) {
    super();
  }

  ngOnInit() {
    this.load();
  }

  setSelected(smartphone: Smartphone) {

    if (this.selectedSmartphone != null && this.selectedSmartphone.id === smartphone.id) {
      return;
    }

    if (this.form?.form?.dirty) {
      const dialogData: ConfirmDialogData = {
        titleKey: 'tmc-yard.ui.admin.smartphone.discard.confirm-dialog.title',
        messageKey: 'tmc-yard.ui.admin.smartphone.discard.confirm-dialog.message',
        confirm: () => {
          this.setSelectedWithoutCheck(smartphone);
        }
      };
      this.dialog.open(ConfirmDialogComponent, {
        data: dialogData
      });
    } else {
      this.setSelectedWithoutCheck(smartphone);
    }

  }

  setSelectedWithoutCheck(smartphone: Smartphone) {

    this.equipmentIdentifier = new EquipmentIdentifier({
      id: smartphone.id,
      typ: EquipmentType.SmartPhone,
    })
    this.setLoading(true);
    this.responseMessages = [];
    if (smartphone != null) {
      this.smartphoneService.getSmartphoneDetails({ id: smartphone.id }).subscribe(details => {
        this.selectedSmartphone = smartphone;
        this.selectedDetails = details;
        this.workingCopyDetails = JSON.parse(JSON.stringify(details));
        this.form.resetForm(this.workingCopyDetails);
        this.setLoading(false);
      }, error => {
        this.setLoading(false);
        console.log(error);
      });
    } else {
      this.setLoading(false);
    }
  }

  isSelected(details: Smartphone) {
    return this.selectedDetails != null && this.selectedDetails.id === details.id;
  }

  delete(smartphone: Smartphone) {

    this.responseMessages = [];

    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.ui.admin.smartphone.delete.confirm-dialog.title',
      messageKey: 'tmc-yard.ui.admin.smartphone.delete.confirm-dialog.message',
      confirm: () => {
        this.setLoading(true);
        this.smartphoneService.deleteSmartphone({ id: smartphone.id }).subscribe(response => {
          if (response.status === ResponseStatus.SUCCESS) {
            this.clearAndLoad();
          } else {
            this.responseMessages = response.responseMessages;
          }
          this.setLoading(false);
        }, error => {
          console.log(error);
          this.setLoading(false);
        });
      }
    };

    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  load() {
    this.setLoading(true);
    this.responseMessages = [];
    this.smartphoneService.getSmartphones().subscribe(smartphones => {

      let newSmartphones = new Array<Smartphone>();
      for (let smartphone of smartphones) {
        newSmartphones.push(new Smartphone(smartphone));
      }
      this.smartphones = newSmartphones;

      if (this.smartphones.length > 0) {
        if (this.selectedSmartphone == null) {
          this.setSelectedWithoutCheck(this.smartphones[0]);
        } else {
          this.setSelectedWithoutCheck(this.smartphones.find(s => s.id === this.selectedSmartphone.id));
        }
      }

      this.setLoading(false);
    }, error => {
      console.error(error);
      this.setLoading(false);
    });
  }

  addNew() {
    if (this.form.form.dirty) {
      const dialogData: ConfirmDialogData = {
        titleKey: 'tmc-yard.ui.admin.smartphone.discard.confirm-dialog.title',
        messageKey: 'tmc-yard.ui.admin.smartphone.discard.confirm-dialog.message',
        confirm: () => {
          this.clear();
        }
      };
      this.dialog.open(ConfirmDialogComponent, {
        data: dialogData
      });
    } else {
      this.clear();
    }
  }

  cancel() {
    if (this.form.form.dirty) {
      const dialogData: ConfirmDialogData = {
        titleKey: 'tmc-yard.ui.admin.smartphone.discard.confirm-dialog.title',
        messageKey: 'tmc-yard.ui.admin.smartphone.discard.confirm-dialog.message',
        confirm: () => {
          this.discardChanges();
        }
      };
      this.dialog.open(ConfirmDialogComponent, {
        data: dialogData
      });
    } else {
      this.discardChanges();
    }
  }

  discardChanges() {
    this.responseMessages = [];
    if (this.workingCopyDetails.id != null) {
      this.setSelectedWithoutCheck(this.selectedSmartphone);
    } else {
      this.workingCopyDetails = new SmartphoneDetails();
      this.form.resetForm(this.workingCopyDetails);
      this.workingCopyDetails.available = true;
      this.selectedSmartphone = null;
    }
  }

  clear() {
    this.responseMessages = [];
    this.selectedSmartphone = null;
    this.selectedDetails = new SmartphoneDetails();
    this.selectedDetails.available = true;
    this.workingCopyDetails = JSON.parse(JSON.stringify(this.selectedDetails));
    this.form.resetForm(this.workingCopyDetails);
  }

  clearAndLoad() {
    this.clear();
    this.load();
  }

  save() {
    if (this.smartphones.some(s => {
      return (this.selectedSmartphone == null && s.nbr === this.workingCopyDetails.nbr) || (this.selectedSmartphone != null && s.id !== this.selectedSmartphone.id && s.nbr === this.workingCopyDetails.nbr);
    }
    )) {
      const dialogData: ConfirmDialogData = {
        titleKey: 'tmc-yard.ui.admin.smartphone.save-duplicate.confirm-dialog.title',
        messageKey: 'tmc-yard.ui.admin.smartphone.save-duplicate.confirm-dialog.message',
        confirm: () => {
          this.saveWithoutCheck();
        }
      };
      this.dialog.open(ConfirmDialogComponent, {
        data: dialogData
      });
    } else {
      this.saveWithoutCheck();
    }
  }

  saveWithoutCheck() {
    this.setLoading(true);
    this.responseMessages = [];
    if (this.workingCopyDetails.id != null) {
      this.updateDetails(this.workingCopyDetails);
    } else {
      this.createDetails(this.workingCopyDetails);
    }
  }

  updateDetails(detailsToUpdate: SmartphoneDetails) {
    this.smartphoneService.saveSmartphone(detailsToUpdate).subscribe(response => {
      this.setLoading(false);
      if (response.status === ResponseStatus.SUCCESS) {
        this.selectedDetails = JSON.parse(JSON.stringify(this.workingCopyDetails));
        this.form.resetForm(this.workingCopyDetails);
        this.load();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.log(error);
      this.setLoading(false);
    });
  }

  createDetails(detailsToAdd: SmartphoneDetails) {
    this.smartphoneService.createSmartphone(detailsToAdd).subscribe(response => {
      this.setLoading(false);
      if (response.status === ResponseStatus.SUCCESS) {
        this.clearAndLoad();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.log(error);
      this.setLoading(false);
    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    this.setSelected(entry as Smartphone);
  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {
    this.addNew();
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    this.delete(entry as Smartphone);
  }

  private setLoading(loading: boolean) {
    this.isLoading = loading;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
